import React, { useState, useEffect, Fragment, useRef } from "react";
import Editor from "../../shared/common/richEditorBox";
import {
  postSkillQuestion,
  updateSkillQuestion,
  getSkillQuestionOne,
  getSkillStandardAll,
  getSkillSubjects,
} from "../../../api/skill.service";
import { Tab } from "@headlessui/react";
import Breadcrumb from "../../shared/common/breadcrumb";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import Constant from "../../../utils/constant";
import { Link, useNavigate } from "react-router";
import { connect } from "react-redux";
import Select from "react-select";
import Loader from "../../shared/loader/loader";
import { DropdownItem } from "../../../model/interface/keyValuePair";
import { toast } from "react-toastify";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import { useNumericParam } from "../../../utils/useNumericParam";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const ManagePracticeQustion: React.FC<any> = (props: any) => {
  const defaultSubjectData: DropdownItem = {
    label: "",
    value: "0",
  };
  const defaultStandardData: DropdownItem = {
    label: "",
    value: "0",
  };
  const navigate = useNavigate();
  const [manageNotification, setManageNotification] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [standard, setStandard] = useState<any>([]);
  const [Instrunction, setInstrunction] = useState<string>("");
  const [isApproved, setisApproved] = useState<boolean>(false);
  const [isCorrect, setisCorrect] = useState<boolean>(false);
  const [isCorrectA, setisCorrectA] = useState<boolean>(false);
  const [isCorrectB, setisCorrectB] = useState<boolean>(false);
  const [isCorrectC, setisCorrectC] = useState<boolean>(false);
  const [editQuestion, seteditQuestion] = useState<any>([]);
  const [editData, setEditData] = useState<any>();
  const [newQuestion, setNewQuestion] = useState<any>("");
  const [newAnsOptionA, setNewAnsOptionA] = useState<any>("");
  const [newAnsOptionB, setNewAnsOptionB] = useState<any>("");
  const [newAnsOptionC, setNewAnsOptionC] = useState<any>("");
  const [newAnsOptionD, setNewAnsOptionD] = useState<any>("");
  const [newSpanishQuestion, setNewSpanishQuestion] = useState<any>("");
  const [newSpanishAnsOptionA, setNewSpanishAnsOptionA] = useState<any>("");
  const [newSpanishAnsOptionB, setNewSpanishAnsOptionB] = useState<any>("");
  const [newSpanishAnsOptionC, setNewSpanishAnsOptionC] = useState<any>("");
  const [newSpanishAnsOptionD, setNewSpanishAnsOptionD] = useState<any>("");
  const [spanishInstrunction, setSpanishInstrunction] = useState<string>("");
  const [newAnsOptionIdA, setNewAnsOptionIdA] = useState<any>([]);
  const [newAnsOptionIdB, setNewAnsOptionIdB] = useState<any>([]);
  const [newAnsOptionIdC, setNewAnsOptionIdC] = useState<any>([]);
  const [newAnsOptionIdD, setNewAnsOptionIdD] = useState<any>([]);
  const [answer, setAnswer] = useState<any>([]);
  const [gradeData, setgradeData] = useState<any>([]);
  const [newStandard, setNewStandard] = useState<any>(defaultSubjectData);
  const [newGrade, setNewGrade] = useState<any>([]);
  const [subjects, setSubjects] = useState<DropdownItem[]>([]);
  const [selectedSubject, setSelectedSubject] =
    useState<DropdownItem>(defaultSubjectData);
  const questionId = useNumericParam("id");

  async function skillSUbject() {
    const SubjectsResponse = getSkillSubjects();
    const subjectData = (await SubjectsResponse).data;
    const subjects = subjectData.data.map((_g) => {
      return {
        label: _g.name,
        value: _g.skillSubjectId,
      };
    });
    setSubjects(subjects);
  }

  useEffect(() => {
    skillSUbject();
    if (editData != null) {
      const selectedSubject = {
        label: editData.skillSubjectName,
        value: editData.skillSubjectId,
      };
      setSelectedSubject(selectedSubject);
      setisApproved(editData && editData.isApproved);
      setNewStandard(newStandard);
      setInstrunction(editData && editData.instruction);
      setSpanishInstrunction(editData && editData.spanishInstruction);
      setNewAnsOptionIdA(
        editData.answers && editData.answers[0]?.skillAnswerId > 0
          ? editData.answers && editData.answers[0]?.skillAnswerId
          : 0
      );
      setNewAnsOptionIdB(
        editData.answers && editData.answers[0]?.skillAnswerId > 0
          ? editData.answers && editData.answers[1]?.skillAnswerId
          : 0
      );
      setNewAnsOptionIdC(
        editData.answers && editData.answers[0]?.skillAnswerId > 0
          ? editData.answers && editData.answers[2]?.skillAnswerId
          : 0
      );
      setNewAnsOptionIdD(
        editData.answers && editData.answers[0]?.skillAnswerId > 0
          ? editData.answers && editData.answers[3]?.skillAnswerId
          : 0
      );
      setisCorrect(
        editData.answers && editData.answers[0]?.skillAnswerId > 0
          ? editData.answers && editData.answers[0]?.isCorrect
          : ""
      );
      setisCorrectA(
        editData.answers && editData.answers[0]?.skillAnswerId > 0
          ? editData.answers && editData.answers[1]?.isCorrect
          : ""
      );
      setisCorrectB(
        editData.answers && editData.answers[0]?.skillAnswerId > 0
          ? editData.answers && editData.answers[2]?.isCorrect
          : ""
      );
      setisCorrectC(
        editData.answers && editData.answers[0]?.skillAnswerId > 0
          ? editData.answers && editData.answers[3]?.isCorrect
          : ""
      );
    }
  }, [editData]);

  useEffect(() => {
    if (editData != null) {
      setNewQuestion(editData && editData?.questionText);
      setNewAnsOptionA(editData.answers && editData.answers[0]?.answerText);
      setNewAnsOptionB(editData.answers && editData.answers[1]?.answerText);
      setNewAnsOptionC(editData.answers && editData.answers[2]?.answerText);
      setNewAnsOptionD(editData.answers && editData.answers[3]?.answerText);
      setNewSpanishQuestion(editData && editData?.spanishQuestionText);
      setNewSpanishAnsOptionA(
        editData.answers && editData.answers[0]?.spanishAnswerText
      );
      setNewSpanishAnsOptionB(
        editData.answers && editData.answers[1]?.spanishAnswerText
      );
      setNewSpanishAnsOptionC(
        editData.answers && editData.answers[2]?.spanishAnswerText
      );
      setNewSpanishAnsOptionD(
        editData.answers && editData.answers[3]?.spanishAnswerText
      );
    }
  }, [editData]);

  useEffect(() => {
    async function SkillQuestion() {
      if (questionId === null || questionId === undefined || questionId === 0) {
        seteditQuestion(null);
        setEditData(null);
      } else if (
        questionId != null ||
        questionId != undefined ||
        questionId > 0
      ) {
        const questionResponse = getSkillQuestionOne(questionId);
        const questionResponseData = (await questionResponse)?.data;
        setEditData(questionResponseData);
        setAnswer(questionResponseData.answers);
        seteditQuestion(questionResponseData);
        const gradeType = {
          label: questionResponseData.gradeName,
          value: questionResponseData.gradeId,
        };
        setNewGrade(gradeType);
        const standardType = {
          label: questionResponseData.skillStandardName,
          value: questionResponseData.skillStandardId,
        };
        setNewStandard(standardType);
        const selectedSubject = {
          label: questionResponseData.skillSubjectName,
          value: questionResponseData.skillSubjectId,
        };
        setSelectedSubject(selectedSubject);
      }
    }
    SkillQuestion();
    getGradeData();
  }, []);

  const getGradeData = async () => {
    const service = await import("../../../api/subject.service");
    const response = service.getGradeAll(100, 1);
    const data = (await response).data;
    let newGradeData = [];
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
      );

      newGradeData = data.data.map((eachGradeData) => {
        return {
          value: eachGradeData.gradeId,
          label: eachGradeData.name,
        };
      });
    }
    setgradeData(newGradeData);
  };
  async function getSkillStandards(subjectId?: number) {
    setLoading(true);
    const gradeSubjectsResponse = getSkillStandardAll(
      newStandard?.value,
      subjectId ? subjectId : selectedSubject.value,
      0,
      true,
      true,
      "name",
      "desc",
      9999,
      1
    );
    const gradeSubjectsData = (await gradeSubjectsResponse).data;
    const standard = gradeSubjectsData.data.map((_g) => {
      return {
        label: `(${_g.code}) ${_g.name}`,
        value: _g.skillStandardId,
      };
    });
    setStandard(standard);
    setLoading(false);
  }

  const onSumbit = () => {
    setManageNotification(true);
    if (
      (isCorrect === false &&
        isCorrectA === false &&
        isCorrectB === false &&
        isCorrectC === false) ||
      newAnsOptionB.length === 0 ||
      newAnsOptionA.length === 0 ||
      newQuestion.length === 0 ||
      Instrunction === "" ||
      newStandard === "" ||
      newGrade === ""
    ) {
      toast.warning("Data cannot be empty");
    } else {
      if (editData != null) {
        let subjectArray1 = {};

        const answersArray = [
          {
            skillAnswerId: newAnsOptionIdA,
            answerText: newAnsOptionA,
            spanishAnswerText: newSpanishAnsOptionA ? newSpanishAnsOptionA : "",
            isCorrect: isCorrect,
          },
          {
            skillAnswerId: newAnsOptionIdB,
            answerText: newAnsOptionB,
            spanishAnswerText: newSpanishAnsOptionB ? newSpanishAnsOptionB : "",
            isCorrect: isCorrectA,
          },
        ];
        if (newAnsOptionIdC > 0) {
          answersArray.push({
            skillAnswerId: newAnsOptionIdC,
            answerText: newAnsOptionC,
            spanishAnswerText: newSpanishAnsOptionC,
            isCorrect: isCorrectB,
          });
        }
        if (newAnsOptionIdD > 0) {
          answersArray.push({
            skillAnswerId: newAnsOptionIdD,
            answerText: newAnsOptionD,
            spanishAnswerText: newSpanishAnsOptionD,
            isCorrect: isCorrectC,
          });
        }
        subjectArray1 = {
          skillQuestionId: editQuestion.skillQuestionId,
          skillSubjectId: selectedSubject.value,
          skillSubjectName: selectedSubject.label,
          gradeId: newGrade.value,
          skillStandardId: newStandard.value,
          instruction: Instrunction,
          questionText: newQuestion,
          spanishInstruction: spanishInstrunction,
          spanishQuestionText: newSpanishQuestion,
          isApproved: isApproved,
          answers: answersArray,
          userId: props.profile?.userId || 1,
        };
        updateSkillQuestion(subjectArray1).then((res) => {
          toast.success("Question Added Successfully");
          navigate(Constant.SKILLPRACTICEQUESTION);
        });
      } else {
        let subjectArray = {};
        const answersArray = [
          {
            answerText: newAnsOptionA,
            spanishAnswerText: newSpanishAnsOptionA ? newSpanishAnsOptionA : "",
            isCorrect: isCorrect,
          },
          {
            answerText: newAnsOptionB,
            spanishAnswerText: newSpanishAnsOptionB ? newSpanishAnsOptionB : "",
            isCorrect: isCorrectA,
          },
        ];
        if (newAnsOptionC.length) {
          answersArray.push({
            answerText: newAnsOptionC,
            spanishAnswerText: newSpanishAnsOptionC ? newSpanishAnsOptionC : "",
            isCorrect: isCorrectB,
          });
        }
        if (newAnsOptionD.length > 0) {
          answersArray.push({
            answerText: newAnsOptionD,
            spanishAnswerText: newSpanishAnsOptionD ? newSpanishAnsOptionD : "",
            isCorrect: isCorrectC,
          });
        }
        subjectArray = {
          gradeId: newGrade.value,
          skillStandardId: newStandard.value,
          skillSubjectId: selectedSubject.value,
          skillSubjectName: selectedSubject.label,
          instruction: Instrunction,
          questionText: newQuestion,
          spanishInstruction: spanishInstrunction ? spanishInstrunction : "",
          spanishQuestionText: newSpanishQuestion ? newSpanishQuestion : "",
          isApproved: isApproved,
          answers: answersArray,
          userId: props.profile?.userId || 1,
        };
        postSkillQuestion(subjectArray).then((res) => {
          toast.success("Question Added Successfully");
          navigate(Constant.SKILLPRACTICEQUESTION);
        });
      }
    }
  };

  const updateMultiDropdownValues = (updateObj, type) => {
    if (type == "Subject") {
      setSelectedSubject(updateObj);
      setNewStandard(defaultStandardData);
      getSkillStandards(updateObj.value);
    } else if (type == "Standard") {
      setNewStandard(updateObj);
    } else if (type == "Grade") {
      setNewGrade(updateObj);
    }
  };

  const [state, setState] = React.useState({ value: null });
  const handleChange = (value) => {
    setState({ value });
  };

  const raidoValues = (e) => {
    if (e.target.value === "A") {
      setisCorrect(true);
      setisCorrectA(false);
      setisCorrectB(false);
      setisCorrectC(false);
    } else if (e.target.value === "B") {
      setisCorrect(false);
      setisCorrectA(true);
      setisCorrectB(false);
      setisCorrectC(false);
    } else if (e.target.value === "C") {
      setisCorrect(false);
      setisCorrectA(false);
      setisCorrectB(true);
      setisCorrectC(false);
    } else if (e.target.value === "D") {
      setisCorrect(false);
      setisCorrectA(false);
      setisCorrectB(false);
      setisCorrectC(true);
    }
  };

  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      { name: "Skill Practice Question", url: Constant.SKILLPRACTICEQUESTION },
      {
        name: editQuestion
          ? "Edit Skill Practice Question"
          : "Add Skill Practice Question",
        url: "",
      },
    ];

    if (editQuestion?.skillQuestionId) {
      items.push({ name: editQuestion?.skillQuestionId, url: "" });
    }

    return items;
  };

  return (
    <AllowedTo
      perform={[
        Permissions.skill_practice_question_create,
        Permissions.skill_practice_question_modify,
      ]}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}

      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 overflow-y-auto mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">
                {editQuestion
                  ? "Edit Skill Practice Question "
                  : "Add Skill Practice Question"}
              </h3>
            </div>
            <Breadcrumb items={breadcrumbItems()} />
            <form>
              <div className="mt-5">
                <div>
                  <div className="grid grid-cols-12 gap-6 ">
                    <div className="col-span-2">
                      <div className="">
                        <div className="text-sm">
                          <label className="font-medium text-gray-700 whitespace-nowrap">
                            Grade <span className="text-red-600">*</span>
                          </label>
                        </div>
                        <div
                          id="grades"
                          className="block w-full mt-1 focus:outline-none focus:ring-pink-700 focus:border-pink-700 sm:text-sm"
                        >
                          <Select
                            options={gradeData}
                            value={newGrade}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            onChange={(e) => {
                              updateMultiDropdownValues(e, "Grade");
                            }}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                          ></Select>
                          {newGrade === "" && manageNotification === true && (
                            <span className="text-red-700 inline-block pt-1 text-sm">
                              Grade is required
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-span-2">
                      <div className="">
                        <div className="text-sm">
                          <label className="font-medium text-gray-700 whitespace-nowrap">
                            Subject <span className="text-red-600">*</span>
                          </label>
                        </div>
                        <div
                          id="grades"
                          className="block w-full mt-1 focus:outline-none focus:ring-pink-700 focus:border-pink-700 sm:text-sm"
                        >
                          <Select
                            options={subjects}
                            value={selectedSubject}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            onChange={(e) => {
                              updateMultiDropdownValues(e, "Subject");
                            }}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                          ></Select>
                        </div>
                      </div>
                    </div>

                    <div className="col-span-2">
                      <div className="">
                        <div className="text-sm">
                          <label className="font-medium text-gray-700 whitespace-nowrap">
                            Standard <span className="text-red-600">*</span>
                          </label>
                        </div>
                        <div
                          id="contentAreaFilter"
                          className="mt-1 block w-full focus:outline-none focus:ring-pink-700 focus:border-pink-700 sm:text-sm"
                        >
                          <Select
                            options={standard}
                            value={newStandard}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            onChange={(e) => {
                              updateMultiDropdownValues(e, "Standard");
                            }}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                          ></Select>
                          {newStandard === "" &&
                            manageNotification === true && (
                              <span className="text-red-700 inline-block pt-1 text-sm">
                                Standard is required
                              </span>
                            )}
                        </div>
                      </div>
                    </div>

                    <div className="col-span-2 flex items-end">
                      <div className="flex items-center">
                        <div>
                          <input
                            id="isApproved"
                            name="isApproved"
                            type="checkbox"
                            checked={isApproved}
                            onChange={(e: any) => {
                              setisApproved(!isApproved);
                            }}
                            className=" focus:ring-primary-color mr-2 h-4 w-4 text-primary-color border-gray-300 rounded"
                          />
                        </div>
                        <div className="text-sm">
                          <label className="font-medium text-gray-700 whitespace-nowrap">
                            Approved
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Tab.Group>
                    <Tab.List className="bg-gray-100 mt-5">
                      <Tab as={Fragment}>
                        {({ selected }) => (
                          <button
                            type="button"
                            className={classNames(
                              selected
                                ? "text-gray-900 topBorder border border-b-0 bg-white"
                                : "text-gray-500 hover:text-gray-700 ",
                              "group relative min-w-0 flex-1 overflow-hidden py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
                            )}
                          >
                            English
                          </button>
                        )}
                      </Tab>
                      <Tab as={Fragment}>
                        {({ selected }) => (
                          <button
                            type="button"
                            className={classNames(
                              selected
                                ? "text-gray-900 topBorder border border-b-0 bg-white"
                                : "text-gray-500 hover:text-gray-700 ",
                              "group relative min-w-0 flex-1 overflow-hidden py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
                            )}
                          >
                            Spanish
                          </button>
                        )}
                      </Tab>
                    </Tab.List>
                    <Tab.Panels>
                      <Tab.Panel className="shadow border-b border-gray-200 sm:rounded-b-lg px-4 py-6 ">
                        <div className="flex flex-row items-center">
                          <div className="text-sm w-32">
                            <label className="font-medium text-gray-700 whitespace-nowrap">
                              Instruction{" "}
                              <span className="text-red-600">*</span>
                            </label>
                          </div>
                          <div className="w-103">
                            <textarea
                              id="instructionEnglish"
                              name="instructionEnglish"
                              style={{ minHeight: "150px" }}
                              value={Instrunction}
                              onChange={(e: any) => {
                                setInstrunction(e.target.value);
                              }}
                              className="mt-1 w-full block border border-gray-300 rounded-md shadow-sm px-3 dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                              required
                            />
                            {Instrunction === "" &&
                              manageNotification === true && (
                                <span className="text-red-700 inline-block pt-1 text-sm">
                                  Instruction is required
                                </span>
                              )}
                          </div>
                        </div>
                        {editQuestion != null &&
                        answer[0]?.answerText === undefined ? (
                          ""
                        ) : (
                          <div className="flex flex-row items-center mt-5">
                            <div className="text-sm w-32">
                              <label className="font-medium text-gray-700 whitespace-nowrap">
                                Question <span className="text-red-600">*</span>
                              </label>
                            </div>
                            <div className="dark:text-white">
                              <Editor
                                editorData={setNewQuestion}
                                editorValue={newQuestion}
                                type={"Question"}
                              />
                              {newQuestion === "" &&
                                manageNotification === true && (
                                  <span className="text-red-700 inline-block pt-1 text-sm">
                                    Question is required
                                  </span>
                                )}
                            </div>
                          </div>
                        )}
                        <div className="flex flex-row items-center mt-5">
                          <div className="text-sm w-32">
                            <label className="font-medium text-gray-700 whitespace-nowrap">
                              Answer
                            </label>
                            {isCorrect === false &&
                              isCorrectA === false &&
                              isCorrectB === false &&
                              isCorrectC === false &&
                              manageNotification === true && (
                                <span className="text-red-700 inline-block pt-1 text-sm">
                                  Select Correct option
                                </span>
                              )}
                          </div>
                          <div>Select the correct option</div>
                        </div>
                        {editQuestion != null &&
                        answer[0]?.answerText === undefined ? (
                          ""
                        ) : (
                          <div className="flex flex-row items-center mt-5">
                            <div className="text-sm w-32">
                              <label className="w-10 text-center text-gray-700 inline-block font-semibold p-2 whitespace-nowrap">
                                A
                              </label>
                              <input
                                type="radio"
                                className="form-radio ml-3 focus:ring-primary-color h-4 w-4 text-primary-color"
                                name="A"
                                value="A"
                                checked={isCorrect}
                                onChange={(e: any) => {
                                  raidoValues(e);
                                }}
                              />
                            </div>
                            <div className="dark:text-white">
                              <Editor
                                editorData={setNewAnsOptionA}
                                editorValue={newAnsOptionA}
                                type={"A"}
                              />
                              {newAnsOptionA === "" &&
                                manageNotification === true && (
                                  <span className="text-red-700 inline-block pt-1 text-sm">
                                    Option A is required
                                  </span>
                                )}
                            </div>
                          </div>
                        )}
                        {editQuestion != null &&
                        answer[1]?.answerText === undefined ? (
                          ""
                        ) : (
                          <div className="flex flex-row items-center mt-5">
                            <div className="text-sm w-32">
                              <label className="w-10 text-center text-gray-700 inline-block font-semibold p-2 whitespace-nowrap">
                                B
                              </label>
                              <input
                                type="radio"
                                className="form-radio ml-3 focus:ring-primary-color h-4 w-4 text-primary-color"
                                name="A"
                                value="B"
                                checked={isCorrectA}
                                onChange={(e: any) => {
                                  raidoValues(e);
                                }}
                              />
                            </div>
                            <div className="dark:text-white">
                              <Editor
                                editorData={setNewAnsOptionB}
                                editorValue={newAnsOptionB}
                                type={"B"}
                              />
                              {newAnsOptionB === "" &&
                                manageNotification === true && (
                                  <span className="text-red-700 inline-block pt-1 text-sm">
                                    Option B is required
                                  </span>
                                )}
                            </div>
                          </div>
                        )}
                        {editQuestion != null &&
                        answer[2]?.answerText === undefined ? (
                          ""
                        ) : (
                          <div className="flex flex-row items-center mt-5">
                            <div className="text-sm w-32">
                              <label className="w-10 text-center text-gray-700 inline-block font-semibold p-2 whitespace-nowrap">
                                C
                              </label>
                              <input
                                type="radio"
                                className="form-radio ml-3 focus:ring-primary-color h-4 w-4 text-primary-color"
                                name="A"
                                value="C"
                                checked={isCorrectB}
                                onChange={(e: any) => {
                                  raidoValues(e);
                                }}
                              />
                            </div>
                            <div className="dark:text-white">
                              <Editor
                                editorData={setNewAnsOptionC}
                                editorValue={newAnsOptionC}
                                type={"C"}
                              />
                            </div>
                          </div>
                        )}
                        {editQuestion != null &&
                        answer[3]?.answerText === undefined ? (
                          ""
                        ) : (
                          <div className="flex flex-row items-center mt-5">
                            <div className="text-sm w-32">
                              <label className="text-center w-10 text-gray-700 inline-block font-semibold p-2 whitespace-nowrap">
                                D
                              </label>
                              <input
                                type="radio"
                                className="form-radio ml-3 focus:ring-primary-color h-4 w-4 text-primary-color"
                                name="A"
                                value={"D"}
                                checked={isCorrectC}
                                onChange={(e: any) => {
                                  raidoValues(e);
                                }}
                              />
                            </div>
                            <div className="dark:text-white">
                              <Editor
                                editorData={setNewAnsOptionD}
                                editorValue={newAnsOptionD}
                                type={"D"}
                              />
                            </div>
                          </div>
                        )}
                      </Tab.Panel>
                      <Tab.Panel className="shadow border-b border-gray-200 sm:rounded-b-lg px-4 py-6 ">
                        <div className="flex flex-row items-center">
                          <div className="text-sm w-32">
                            <label className="font-medium text-gray-700 whitespace-nowrap">
                              Instruction{" "}
                              <span className="text-red-600">*</span>
                            </label>
                          </div>
                          <div className="w-103">
                            <textarea
                              id="instrunctionSpanish"
                              name="instrunctionSpanish"
                              value={
                                spanishInstrunction
                                  ? spanishInstrunction
                                  : editQuestion
                                  ? Instrunction
                                  : ""
                              }
                              style={{ minHeight: "150px" }}
                              onChange={(e: any) => {
                                setSpanishInstrunction(e.target.value);
                              }}
                              className="mt-1 w-full block border border-gray-300 rounded-md shadow-sm px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                              required
                            />

                            {spanishInstrunction === "" &&
                              manageNotification === true && (
                                <span className="text-red-700 inline-block pt-1 text-sm">
                                  Spanish instruction is required
                                </span>
                              )}
                          </div>
                        </div>
                        {editQuestion != null &&
                        answer[0]?.answerText === undefined ? (
                          ""
                        ) : (
                          <div className="flex flex-row items-center mt-5">
                            <div className="text-sm w-32">
                              <label className="font-medium text-gray-700 whitespace-nowrap">
                                Question <span className="text-red-600">*</span>
                              </label>
                            </div>
                            <div className="dark:text-white">
                              <Editor
                                editorData={setNewSpanishQuestion}
                                editorValue={
                                  newSpanishQuestion
                                    ? newSpanishQuestion
                                    : questionId
                                    ? newQuestion
                                    : ""
                                }
                                type={"Question"}
                              />

                              {newSpanishQuestion === "" &&
                                manageNotification === true && (
                                  <span className="text-red-700 inline-block pt-1 text-sm">
                                    Spanish question is required
                                  </span>
                                )}
                            </div>
                          </div>
                        )}
                        <div className="flex flex-row items-center mt-5">
                          <div className="text-sm w-32">
                            <label className="font-medium text-gray-700 whitespace-nowrap">
                              Answer
                            </label>
                          </div>
                          <div>Select the correct option</div>
                        </div>
                        {editQuestion != null &&
                        answer[0]?.answerText === undefined ? (
                          ""
                        ) : (
                          <div className="flex flex-row items-center mt-5">
                            <div className="text-sm w-32">
                              <label className="w-10 text-center text-gray-700 inline-block font-semibold p-2 whitespace-nowrap">
                                A
                              </label>
                              <input
                                type="radio"
                                className="form-radio ml-3 focus:ring-primary-color h-4 w-4 text-primary-color"
                                name="A"
                                value="A"
                                checked={isCorrect}
                                onChange={(e: any) => {
                                  raidoValues(e);
                                }}
                              />
                            </div>

                            <div className="dark:text-white">
                              <Editor
                                editorData={setNewSpanishAnsOptionA}
                                editorValue={
                                  newSpanishAnsOptionA
                                    ? newSpanishAnsOptionA
                                    : questionId
                                    ? newAnsOptionA
                                    : ""
                                }
                                type={"A"}
                              />
                            </div>
                          </div>
                        )}
                        {editQuestion != null &&
                        answer[1]?.answerText === undefined ? (
                          ""
                        ) : (
                          <div className="flex flex-row items-center mt-5">
                            <div className="text-sm w-32">
                              <label className="w-10 text-center text-gray-700 inline-block font-semibold p-2 whitespace-nowrap">
                                B
                              </label>
                              <input
                                type="radio"
                                className="form-radio ml-3 focus:ring-primary-color h-4 w-4 text-primary-color"
                                name="A"
                                value="B"
                                checked={isCorrectA}
                                onChange={(e: any) => {
                                  raidoValues(e);
                                }}
                              />
                            </div>
                            <div className="dark:text-white">
                              <Editor
                                editorData={setNewSpanishAnsOptionB}
                                editorValue={
                                  newSpanishAnsOptionB
                                    ? newSpanishAnsOptionB
                                    : questionId
                                    ? newAnsOptionB
                                    : ""
                                }
                                type={"B"}
                              />
                            </div>
                          </div>
                        )}
                        {editQuestion != null &&
                        answer[2]?.answerText === undefined ? (
                          ""
                        ) : (
                          <div className="flex flex-row items-center mt-5">
                            <div className="text-sm w-32">
                              <label className="w-10 text-center text-gray-700 inline-block font-semibold p-2 whitespace-nowrap">
                                C
                              </label>
                              <input
                                type="radio"
                                className="form-radio ml-3 focus:ring-primary-color h-4 w-4 text-primary-color"
                                name="A"
                                value="C"
                                checked={isCorrectB}
                                onChange={(e: any) => {
                                  raidoValues(e);
                                }}
                              />
                            </div>
                            <div className="dark:text-white">
                              <Editor
                                editorData={setNewSpanishAnsOptionC}
                                editorValue={
                                  newSpanishAnsOptionC
                                    ? newSpanishAnsOptionC
                                    : questionId
                                    ? newAnsOptionC
                                    : ""
                                }
                                type={"C"}
                              />
                            </div>
                          </div>
                        )}
                        {editQuestion != null &&
                        answer[3]?.answerText === undefined ? (
                          ""
                        ) : (
                          <div className="flex flex-row items-center mt-5">
                            <div className="text-sm w-32">
                              <label className="w-10 text-center text-gray-700 inline-block font-semibold p-2 whitespace-nowrap">
                                D
                              </label>
                              <input
                                type="radio"
                                className="form-radio ml-3 focus:ring-primary-color h-4 w-4 text-primary-color"
                                name="A"
                                value={"D"}
                                checked={isCorrectC}
                                onChange={(e: any) => {
                                  raidoValues(e);
                                }}
                              />
                            </div>
                            <div className="dark:text-white">
                              <Editor
                                editorData={setNewSpanishAnsOptionD}
                                editorValue={
                                  newSpanishAnsOptionD
                                    ? newSpanishAnsOptionD
                                    : questionId
                                    ? newAnsOptionD
                                    : ""
                                }
                                type={"D"}
                              />
                            </div>
                          </div>
                        )}
                      </Tab.Panel>
                    </Tab.Panels>
                  </Tab.Group>
                  <div className="flex justify-end mt-2 items-center ">
                    <button
                      type="button"
                      className="inline-flex items-center px-3 py-2 my-3 hover:bg-secondary-color border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                      onClick={onSumbit}
                    >
                      {editQuestion ? "Update" : "Save"}
                    </button>
                    <Link to={Constant.SKILLPRACTICEQUESTION} className="ml-2">
                      <button className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color">
                        Cancel
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};
const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};

export default connect(mapStateToProps, {})(ManagePracticeQustion);
